export default function getHostname(hostname) {
	if (!hostname && window) {
		hostname = window.location.hostname;
	}

	return hostname.replace(/\.localhost$/, '');
}
